import React, { useState } from 'react'
import Modal from '../../../../components/Modal'
import ChatMessages from '../ChatBody/ChatMessages'
import { IoChatbubbleEllipses } from 'react-icons/io5'

const ChatModal = ({ selectedChatMemberData, headerName = null }) => {
    const [modal, setModal] = useState(false)

    const handleBlockedChannel = () => {
        return null
    }

    return (
        <React.Fragment>
            <div
                className='flex cursor-pointer rounded-md justify-center items-center'
                onClick={() => setModal(true)}
            >
                <div className='rounded-full bg-[#fab700] p-2 mr-2'>
                    <IoChatbubbleEllipses color='white' size={14} />
                </div>
                <span className='inherit'>Message</span>
            </div>

            <Modal.Basic open={modal} onCancel={() => setModal(false)} width={400}>
                <div className="w-full overflow-y-auto">
                    <div className="flex bg-primary p-4 w-full">
                        <h6 className="heading-6 font-bold">
                            {headerName ? headerName : selectedChatMemberData?.fullName}
                        </h6>
                    </div>
                    <div className='p-4'>
                        <ChatMessages
                            selectedChatMemberData={selectedChatMemberData}
                            isModal
                            refreshData={null}
                            resetRefreshData={null}
                            handleBlockedChannel={handleBlockedChannel}
                        />
                    </div>
                </div>
            </Modal.Basic>
        </React.Fragment>
    )
}

export default ChatModal